require('./receiptPreview.scss')

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames')
const { formatText } = require('core/i18n').i18n;
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname')

const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
import { OKIconButton } from 'commonsComponents/OKIconButton';
import { OKButton } from 'commonsComponents/OKButton';
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

class ReceiptPreview extends React.PureComponent {

    renderNoPreview(){
        const previewError = formatText('ReceiptPreview-PreviewError');

        return (
            <EmptyState primaryText={previewError} iconType="nointernet-banking"/>
        )
    }

    render() {
        const {
            downloading,
            error,
            immAccountReceiptDownload,
            loading,
            onClickDownloadButton,
            title,
            src,
        } = this.props;
        const loadingPdf = immAccountReceiptDownload && immAccountReceiptDownload.get('inProgress');
        const classname = classNames({
            "receipt-preview--downloading": downloading
        })
        if (loading) {
            return <LoadingSection />
        } else {
            if (error || !src)
                return this.renderNoPreview()
            if (src) {
                const iconClassName = conditionalClassName('icon-descargar', 'icon-mostrar icon-modifier-small', 'aggregator-accordion__header__icon icon pull-right')
                const content = (
                    <span className="pull-right">
                        <ContactCenterRender>
                            <OKButton
                                onClick={onClickDownloadButton}
                                size="small"
                                loaderSize="small"
                                modifier="task"
                                loading={loadingPdf}
                            >
                                <i className={iconClassName} />
                            </OKButton>
                        </ContactCenterRender>
                        <WebappRender>
                            <OKIconButton
                                icon={iconClassName}
                                onClick={onClickDownloadButton}
                                size="small"
                            />
                        </WebappRender>
                    </span>
                );
                const contentTooltip = __CONTACT_CENTER__ ? 'accountMovements-previewReceipt' : 'accountMovements-downloadReceipt';

                return (
                    <div className={`receipt-preview__container ${classname}`} >
                        <img className="receipt-preview__image" src={src}/>
                        {
                            downloading &&
                            <div className="receipt-preview__loading-div">
                                <div className="receipt-preview__loading-div__background"/>
                                <LoadingSection />
                            </div>
                        }
                        <div className="receipt-preview__footer">
                            { title && <span className="receipt-preview__footer-text" >{title}</span> }
                            <OKTooltip
                                target={content}
                                offset={[0, -10]}
                                content={contentTooltip}
                            />
                        </div>
                    </div>
                )
            }
        }
    }
}

ReceiptPreview.propTypes = {
    error: PropTypes.object,
    downloading: PropTypes.bool,
    immAccountReceiptDownload: PropTypes.object,
    loading: PropTypes.bool,
    onClickDownloadButton: PropTypes.func,
    title: PropTypes.string,
    src: function(props, propName, componentName) {
        if (props[propName] && !/data:(.+)base64,(.+)/.test(props[propName])) {
            return new Error(
                'Invalid value of`' + propName + '` supplied to' +
                ' `' + componentName + '`. Must be base64.'
            );
        }
    }
}

export { ReceiptPreview }
